import React from 'react';
import Checkbox from './Checkbox';
export default function Radio(props) {
    return React.createElement(Checkbox, Object.assign({ type: "radio" }, props));
}
